import { Node } from 'tiptap';
import { sinkListItem, splitToDefaultListItem, liftListItem } from 'tiptap-commands';

import TodoItemNode from '@/components/editor/nodes/TodoItemNode.vue';

export default class TodoItem extends Node {
  get name() {
    return 'todo_item';
  }

  get view() {
    return TodoItemNode;
  }

  get schema() {
    return {
      attrs: {
        done: {
          default: false,
        },
      },
      draggable: true,
      content: 'paragraph (paragraph|todo_list)*',
      toDOM: node => {
        const { done } = node.attrs;

        return [
          'li',
          {
            class: 'todo-item',
            'data-done': done.toString(),
            'data-type': this.name,
          },
          [
            'div',
            {
              class: 'checkbox',
            },
            [
              'input',
              {
                type: 'checkbox',
                checked: done ? '' : undefined,
                disabled: '',
              },
            ],
            ['label'],
          ],
          ['div', 0],
        ];
      },
      parseDOM: [{
        priority: 51,
        tag: `li[data-type="${this.name}"]`,
        getAttrs: dom => ({
          done: dom.getAttribute('data-done') === 'true',
        }),
      }],
    };
  }

  keys({ type }) {
    return {
      Enter: splitToDefaultListItem(type),
      Tab: sinkListItem(type),
      'Shift-Tab': liftListItem(type),
    };
  }
}
